module.exports = __webpack_public_path__ + "static/media/es.97530017.svg";